app.controller("bookDemoController", [
    "$scope",
    "$uibModalInstance",
    "$timeout",
    "EmailAPI",
    "selectedPlan",
    function ($scope, $uibModalInstance, $timeout, EmailAPI, selectedPlan) {

        $scope.demoRequest = {
            plan: selectedPlan
        };
        $scope.selectedPlan = selectedPlan;
        $scope.formSubmitted = false;
        $scope.isSubmitting = false;
        $scope.submitError = null;
        $scope.EA = EmailAPI;

        $scope.submitDemoRequest = function (isValid) {
            if (!isValid || $scope.isSubmitting) {
                return;
            }

            if ($scope.selectedPlan === 'Essential Optometrist') {
                $scope.demoRequest.message = $scope.demoRequest.registrationNumber + ' ' + $scope.demoRequest.phoneNumber;
            }

            $scope.demo_request = {
                "full_name": $scope.demoRequest.fullName,
                "practice_name": $scope.demoRequest.practiceName,
                "email": $scope.demoRequest.email,
                "plan_type": $scope.demoRequest.plan,
                "registration_number": $scope.demoRequest.registrationNumber,
                "phone_number": $scope.demoRequest.phoneNumber,
                "message": $scope.demoRequest.message,
            }

            $scope.isSubmitting = true;
            $scope.submitError = null;

            // The thank-you screen waits on the server. Showing it up front told visitors their
            // enquiry had been received when a rejected plan type or a dropped connection meant
            // nothing had been sent, and they had no reason to try again.
            $scope.EA.demo($scope.demo_request)
                .then(function () {
                    $scope.formSubmitted = true;

                    $timeout(function () {
                        $uibModalInstance.close('form_submitted');
                    }, 3000);
                })
                .catch(function () {
                    // The form is left filled in and open, so retrying costs nothing.
                    $scope.submitError =
                        "We could not send your request just now. Please try again, or email us at andrew.emery@cattrax.co.nz.";
                })
                .finally(function () {
                    $scope.isSubmitting = false;
                });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
]);